import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6c78b6d0&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QField,QToolbar,QSelect});
